import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ReactiveFormsModule} from '@angular/forms';
import {DashboardComponent} from './dashboard.component';
import {DashboardRoutingModule} from './dashboard-routing.module';
import {DashboardService} from './services/dashboard.service';

import {ConmetInputModule} from '../custom-component/conmet-input/conmet-input.module';
import {ConmetInputNumberModule} from '../custom-component/conmet-input-number/conmet-input-number.module';
import {ConmetSelectModule} from '../custom-component/conmet-select/conmet-select.module';
import { UsatiModule } from '../usati/usati.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DashboardRoutingModule,
    ConmetInputModule,
    ConmetInputNumberModule,
    ConmetSelectModule,
    UsatiModule,
  ],
  declarations: [DashboardComponent],
  providers: [
    DashboardService
  ]
})
export class DashboardModule {
}
